











































































































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import { getModule } from 'vuex-module-decorators';
import WhiteLabelData from '@/data/WhiteLabelData';
import WhiteLabelModule from '@/store/modules/WhiteLabel';
import GeneralModule from '@/store/modules/General';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import { ENV } from '@/utils/api';

@Component({
  components: {
    Table,
  },
})
export default class AgentSettingView extends Mixins(ErrorHandleMixin) {
  TableHead = WhiteLabelData.TableHead;

  WhiteLabelInstance = getModule(WhiteLabelModule, this.$store);

  GeneralInstance = getModule(GeneralModule, this.$store);

  BannerModel = WhiteLabelData.initialModel();

  currentSelection: any = {};

  isOpenRemove = false;

  mode = '';

  file: any = null;

  url: any = null;

  isImage = false;

  searchText = '';

  data = [];

  colors = [];

  partImage = '';

  type = '';

  name = '';

  agent = '';

  async created() {
    await this.fetchSetting();
  }

  async fetchSetting() {
    const res = await this.WhiteLabelInstance.FetchSettingImage();
    this.data = this.WhiteLabelInstance.list;
    this.colors = this.WhiteLabelInstance.list.agentTheme;
    const favicon = document.getElementById('favicon');
    favicon.setAttribute('href', this.data.image.agent.favicon);
    if (res.code) {
      this.checkError(res);
    }
  }

  handleSearch() {
    this.data = this.WhiteLabelInstance.list
      .filter((item) => item.description.includes(this.searchText));
  }

  uploadImage(files) {
    const [file] = files;
    this.url = URL.createObjectURL(file);
    this.file = file;
    this.isImage = true;
  }

  openModal(key, index, data) {
    this.type = key;
    this.name = index;
    this.agent = data.agent;
    this.BannerModel = WhiteLabelData.initialModel();
    this.url = null;
    this.mode = index > -1 ? 'Update' : 'Create';
    if (index > -1) {
      this.BannerModel = { ...this.WhiteLabelInstance.list[index] };
      this.url = this.BannerModel.imagePath;
      // this.partImage = `${ENV}/${this.BannerModel.}`
    }
  }

  async submit() {
    if (this.file) {
      const env = ['local', 'sit'].includes(ENV) ? 'sit' : ENV;
      this.partImage = `https://asset-images.asp78coll.com/${env}/${this.agent}/${this.type}/${this.file.name}`;
      this.GeneralInstance.toggleLoading(true);
      const photo = this.file;
      const formData = new FormData();
      formData.append('type', this.type);
      formData.append('name', this.name);
      formData.append('partImage', `${env}/${this.agent}/${this.type}/${this.file.name}`);
      formData.append('photo', photo);
      const param = {
        type: this.type,
        name: this.name,
        url: this.partImage,
      };
      const res = await this.WhiteLabelInstance.UploadImage(formData);
      this.checkError(res.status);
      if (res.status.code === 0) {
        const _res = await this.WhiteLabelInstance.ImageUpdate(param);
        this.checkError(_res.status);
      }
      this.GeneralInstance.toggleLoading(false);
    }
    this.mode = '';
    this.file = '';
    this.fetchSetting();
  }

  @Watch('colors', { immediate: true, deep: true })
  onChangeReport(val) {
    Object.keys(val).forEach((item) => {
      document.body.style.setProperty(`--${item}`, val[item]);
    });
  }

  async submitColor() {
    const theme = {
      agentTheme: this.colors,
    };
    const res = await this.WhiteLabelInstance.EditSettingTheme(theme);
    this.checkError(res.status);
  }
}
